import {HomeState} from "../../interfaces/store/reducers/homeState";
import {
    CLEAR_HOME_DATA, SET_ANNOUNCEMENTS, SET_HOME_JOBS,
} from "../actions/availableActions";
import {
    ClearHomeDataAction, SetAnnouncementsAction, SetHomeJobsAction,
} from "../../interfaces/store/actions/home";
import {JobsHomeData} from "../../interfaces/store/actions/payload/home";

const initialState: HomeState = {
    availableJobs: [],
    inProgressJobs: [],
    announcements: [],
};

type AvailableActions = SetHomeJobsAction
| SetAnnouncementsAction
| ClearHomeDataAction;

const homeReducer = (state:HomeState = initialState, action: AvailableActions): HomeState => {
    switch (action.type) {
        case SET_HOME_JOBS: {
            const {availableJobs, inProgressJobs}: JobsHomeData = action.payload;
            return {
                ...state,
                availableJobs,
                inProgressJobs,
            };
        }
        case SET_ANNOUNCEMENTS: {
            return {
                ...state,
                announcements: action.payload,
            };
        }
        case CLEAR_HOME_DATA: {
            return {
                ...initialState,
            };
        }
        default:
            return state;
    }
};

export default homeReducer;
